import { useEffect, useState } from "react";
import axios from "axios";
import platform from "platform";
import { toast } from "react-toastify";
import { forgetPassword } from "../../redux/actions/auth";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightToBracket } from "@fortawesome/free-solid-svg-icons";
import ResetPasswordModal from "../../components/modals/ResetPasswordModal";

const ResetPassword = () => {

  const dispatch = useDispatch()
  const { loading, info } = useSelector((state) => state.auth);
  // const [open, setOpen] = useState(true)
  const [accountNumber, setAccountNumber] = useState('')
  const [ip, setIp] = useState('')
  // const [showPassword, setShowPassword] = useState(false);
  const [browserName, setBrowserName] = useState("");


  const getData = async () => {
    try {
      const res = await axios.get("https://api.ipify.org/?format=json");
      setIp(res?.data?.ip || "");
    } catch (err) {
      setIp("");
    }
  }; 

  useEffect(() => {
    setBrowserName(platform.name);
    getData();
  }, [dispatch])


  const handleSubmit = (e) => {
    e.preventDefault()
    const trimmedAccountNumber = accountNumber.trim();

    if(!trimmedAccountNumber) {
      toast.error('Phone number is required to continue reset')
    }else{
      dispatch(forgetPassword({
        ip,
        browserName,
        accountNumber: trimmedAccountNumber,
      }))
    }
  };


  return (
    <div className="m-0 font-sans antialiased font-normal bg-white text-start text-base leading-default text-slate-500">
      <div className="container sticky top-0 z-sticky ">
    
      </div>
      <main className="mt-0 transition-all duration-200 ease-soft-in-out">
        <section>
          <div className="relative flex items-center p-0 overflow-hidden bg-center bg-cover min-h-75-screen">
            <div className="container z-10">
              <div className="flex flex-wrap mt-0 -mx-3">
                <div className="flex flex-col w-full max-w-full px-3 mx-auto md:flex-0 shrink-0 md:w-6/12 lg:w-5/12 xl:w-4/12">
                  <div className="relative flex flex-col min-w-0 mt-32 break-words bg-transparent border-0 shadow-none rounded-2xl bg-clip-border">
                    <div className="p-6 pb-0 mb-0 bg-transparent border-b-0 rounded-t-2xl">
                      <h3 className="relative z-10 font-bold text-transparent bg-gradient-to-tl from-primary to-primary-light bg-clip-text">
                        Password Reset
                      </h3>
                      <p className="mb-0">
                        Enter your Client Code to continue password reset.
                      </p>
                    </div>
                    <div className="flex-auto p-6">
                      <form>
                        <label className="mb-2 ml-1 font-bold text-xs text-primary">
                          Enter Client Code / Mobile Number
                        </label>
                        <div className="mb-4">
                          <input
                            type="text"
                            value={accountNumber}
                            className="focus:shadow-primary-dark text-sm leading-5.6 ease-soft block w-full appearance-none rounded-lg border border-solid border-gray-300 bg-white bg-clip-padding px-3 py-2 font-normal text-secondary-dark transition-all focus:border-primary-dark focus:outline-none focus:transition-shadow placeholder-secondary"
                            placeholder="Eg: 0886...."
                            aria-label="accountNumber"
                            aria-describedby="email-addon"
                            onChange={(e) => setAccountNumber(e.target.value)}
                          />
                        </div>


                        <div className="text-center">
                          <button
                          onClick={handleSubmit}
                            type="button"
                            className="inline-block w-full px-6 py-3 mt-6 mb-0 font-bold text-center text-white uppercase align-middle transition-all bg-transparent border-0 rounded-lg cursor-pointer shadow-soft-md bg-x-25 bg-150 leading-pro text-xs ease-soft-in tracking-tight-soft bg-gradient-to-tl from-primary-dark to-primary hover:scale-102 hover:shadow-soft-xs active:opacity-85"
                          >

                            {loading ? <>loading ...</> : <><FontAwesomeIcon
                              icon={faRightToBracket}
                              className="mr-2"
                            />
                            Reset Password</>}
                          </button>
                        </div>
                      </form>
                    </div>
                    <div className="p-6 px-1 pt-0 text-center bg-transparent border-t-0 border-t-solid rounded-b-2xl lg:px-2">
                    <p className="mx-auto mb-6 leading-normal text-sm">
                        Still Remember your Credentials
                      <a href="/" className="relative z-10 font-semibold text-transparent bg-gradient-to-tl from-blue-600 to-cyan-400 bg-clip-text"> Sign In</a>
                    </p>
                  </div>
                  </div>
                </div>
                <div className="w-full max-w-full px-3 lg:flex-0 shrink-0 md:w-6/12">
                  <div className="absolute top-0 hidden w-3/5 h-full -mr-32 overflow-hidden -skew-x-10 -right-40 rounded-bl-xl md:block">
                  <div
                      className="absolute inset-x-0 top-10 z-0 h-full -ml-16 bg-contain skew-x-10"
                      style={{
                        backgroundImage: `url("/assets/img/accessBankBanner.jpg")`,
                      }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <footer className="py-12">
        <div className="container">
          <div className="flex flex-wrap -mx-3">
            {/* <div className="flex-shrink-0 w-full max-w-full mx-auto mb-6 text-center lg:flex-0 lg:w-8/12">
              <a
                href="/"
                target="_blank"
                className="mb-2 mr-4 text-primary-dark sm:mb-0 xl:mr-12"
              >
                {" "}
                Website{" "}
              </a>
              <a
                href="/"
                target="_blank"
                className="mb-2 mr-4 text-primary-dark sm:mb-0 xl:mr-12"
              >
                {" "}
                About Us{" "}
              </a>
              <a
                href="/"
                target="_blank"
                className="mb-2 mr-4 text-primary-dark sm:mb-0 xl:mr-12"
              >
                {" "}
                Team{" "}
              </a>
              <a
                href="/"
                target="_blank"
                className="mb-2 mr-4 text-primary-dark sm:mb-0 xl:mr-12"
              >
                {" "}
                Products{" "}
              </a>
              <a
                href="/"
                target="_blank"
                className="mb-2 mr-4 text-primary-dark sm:mb-0 xl:mr-12"
              >
                {" "}
                Contact{" "}
              </a>
            </div>
            <div className="flex-shrink-0 w-full max-w-full mx-auto mt-2 mb-6 text-center lg:flex-0 lg:w-8/12">
              <a href="/" target="_blank" className="mr-6 text-primary-dark">
                <span className="text-lg fab fa-dribbble"></span>
              </a>
              <a href="/" target="_blank" className="mr-6 text-primary-dark">
                <span className="text-lg fab fa-twitter"></span>
              </a>
              <a href="/" target="_blank" className="mr-6 text-primary-dark">
                <span className="text-lg fab fa-instagram"></span>
              </a>
              <a href="/" target="_blank" className="mr-6 text-primary-dark">
                <span className="text-lg fab fa-pinterest"></span>
              </a>
              <a href="/" target="_blank" className="mr-6 text-primary-dark">
                <span className="text-lg fab fa-github"></span>
              </a>
            </div> */}
          </div>

          {info ? <ResetPasswordModal username={accountNumber} /> : ''}       
          <div className="flex flex-wrap -mx-3">
            <div className="w-8/12 max-w-full px-3 mx-auto mt-1 text-center flex-0">
              <p className="mb-0 text-primary-dark">
                Powered by <a href="https://bigmove.dev">BigMove LLC</a>.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ResetPassword;
